import getDateFromString from "@/helpers/getDateFromString";

export default function getDate(dateInString, yearFirst = false) {
    const {year, month, day} = getDateFromString(dateInString);
    if (yearFirst) {
        return `${year}-${month}-${day}`;
    } else {
        return `${day}-${month}-${year}`;
    }
}